import ViewOrder from "../../components/Orders/View";
import PageTitleComponent from "../../components/PageTitle";

export default function OrderDetailsScreen(){
return <div>
    <PageTitleComponent title="Order Details" />
    <ViewOrder/>
</div>
}